import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { defaultStaleTime } from '../../../config/queryClient'
import { QueryKeys } from '../../../enums/queryKeys'
import { fetchFolderContents } from '../query-api'
import type { DmsDocument, DmsFolder } from '../types'

interface UseFetchFolderContentsOptions {
  enabled?: boolean
  retry?: boolean | number
}

export const useFetchFolderContents = (
  folderId: string,
  { enabled = true, retry }: UseFetchFolderContentsOptions = {},
) => {
  const { organization } = useUserOrganization()

  const { data, isLoading, isError, error } = useQuery(
    [QueryKeys.DmsFolderContents, folderId],
    () => fetchFolderContents(organization?.id as string, folderId),
    {
      enabled: enabled && Boolean(organization?.id) && !!folderId,
      staleTime: defaultStaleTime,
      ...(retry !== undefined && { retry }),
    },
  )

  const documents: DmsDocument[] = useMemo(() => data?.documents ?? [], [data])
  const folders: DmsFolder[] = useMemo(() => data?.folders ?? [], [data])

  return {
    documents,
    folders,
    isFolderContentsLoading: isLoading,
    isError,
    error,
    isEmpty: !isLoading && documents.length === 0 && folders.length === 0,
  }
}
